import keyMirror from 'keymirror';

// Define action constants
export default keyMirror({
  RECEIVE_FOOTER_BAR_DATA: null // After postback

});
